import { useDisciplineStore } from '@stores/discipline'
import { useCustomerStore } from '@stores/me/customer'
import { useAssessmentTestStore } from '@stores/assessment-test'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'
import { getNotifyChannelFromUrl } from '@tools/amplitude/notify-channel'
import { getNotifyTypeFromUrl } from '@tools/amplitude/notify-type'

interface AssessmentTestAnalyticsReturn {
  setAssessmentPageView: () => void
  setAssessmentResultPageView: () => void
  setAssessmentCompilingPageView: () => void
}

export const useAssessmentTestAnalytics = (): AssessmentTestAnalyticsReturn => {
  const disciplineStore = useDisciplineStore()
  const customerStore = useCustomerStore()
  const assessmentTestStore = useAssessmentTestStore()

  const setAssessmentPageView = (): void => {
    trackEvent(amplitudeConfig.events.pageViewAssessmentTest, {
      discipline_id: disciplineStore.getDisciplineInfo?.id,
      discipline_code: disciplineStore.getDisciplineCode,
      notify_type: getNotifyTypeFromUrl(),
      notify_channel: getNotifyChannelFromUrl(),
      customer_type: customerStore.getCustomer?.type,
      source_funnel: customerStore.getCustomer?.source_funnel,
      question_name: assessmentTestStore.getCurrentQuestion?.name,
      question_title: assessmentTestStore.getCurrentQuestion?.title,
      comprehension: assessmentTestStore.isComprehension,
    })
  }

  const setAssessmentResultPageView = (): void => {
    trackEvent(amplitudeConfig.events.pageViewAssessmentResult, {
      discipline_id: disciplineStore.getDisciplineInfo?.id,
      discipline_code: disciplineStore.getDisciplineCode,
      notify_type: getNotifyTypeFromUrl(),
      notify_channel: getNotifyChannelFromUrl(),
      customer_type: customerStore.getCustomer?.type,
      source_funnel: customerStore.getCustomer?.source_funnel,
    })
  }

  const setAssessmentCompilingPageView = (): void => {
    trackEvent(amplitudeConfig.events.pageViewAssessmentCompiling, {
      discipline_id: disciplineStore.getDisciplineInfo?.id,
      discipline_code: disciplineStore.getDisciplineCode,
      notify_type: getNotifyTypeFromUrl(),
      notify_channel: getNotifyChannelFromUrl(),
      customer_type: customerStore.getCustomer?.type,
      source_funnel: customerStore.getCustomer?.source_funnel,
    })
  }

  return {
    setAssessmentPageView,
    setAssessmentResultPageView,
    setAssessmentCompilingPageView,
  }
}
